import * as Sentry from '@sentry/react'
import { extractCookiesData } from '../helpers/cookieHelpers'

export function initSentry() {
    const { statisticAllowed } = extractCookiesData()

    console.log('[Sentry] Cookies extracted:', { statisticAllowed })

    if (!statisticAllowed) return

    Sentry.init({
        dsn: 'https://a4abf369a456074fb70f84081165999e@o4506197688647680.ingest.us.sentry.io/4506707730825216',
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: [/.*/],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        environment: process.env.ENV,
        beforeSend: (event) => {
            if (process.env.ENV === 'local') return null

            const exception = event.exception?.values?.[0]?.value
            if (exception?.includes('Timeout')) return null

            if (event.message?.includes('Non-Error promise rejection captured with value: Timeout')) return null

            return event
        },
    })
}
